<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
// [TODO] сменить на VNotification когда будет готова

const LABEL_PRODUCT_NOTICE =
  "Количество товара ограничено, информацию о наличии уточняйте в магазине.";

withDefaults(defineProps<{ text?: string }>(), {
  text: LABEL_PRODUCT_NOTICE,
});
</script>

<template>
  <section class="product-details-notice">
    <VText tag="div" font="body-large-accent-low">
      {{ text }}
    </VText>
  </section>
</template>

<style lang="postcss" scoped>
.product-details-notice {
  margin-top: var(--pl-unit-x1);
  background: var(--pl-surface-muted-default);
  padding: var(--pl-unit-x4);
  border-radius: var(--pl-unit-x3);
}
</style>
